import React from "react";
import { Col, Row } from 'antd';
const WhyGreen = () => {
  return (
    <div className="why-green">
      <div className="k2s-green-container defaultPadding">
        <div className="header-title" data-aos="fade-up" data-aos-duration="1200">
          <h2 className="title-center">Why K2S Green </h2>
          <p className="title-center">
            Today’s evolving energy landscape demands a bold response.
            Balancing economic growth with environmental stewardship isn’t
            just an aspiration—it’s a strategic necessity for a sustainable
            future.
          </p>
        </div>
        <div className="why-green-wrapper">

            <Row gutter={16} className="pdt50" >
                <Col className="gutter-row coltype"  xs={24} sm={12} md={8}>
                <div className="columnStyle2 s1" data-aos="flip-left" data-aos-duration="1200">
                      <div className="counter">93%</div>
                      <p>of CEOs believe sustainability is critical to their company’s future (UN Global Compact, 2023)</p>
                  </div>
                </Col>
                <Col className="gutter-row coltype" xs={24} sm={12} md={8}>
                <div className="columnStyle2 s1" data-aos="flip-left" data-aos-duration="1200">
                        <div className="counter">$1 trillion</div>
                        <p>is the expected annually clean energy investments by 2030 (IEA)</p>
                    </div>
                </Col>
                <Col className="gutter-row coltype" xs={24} sm={12} md={8}>
                    <div className="columnStyle2 s1" data-aos="flip-left" data-aos-duration="1200">
                      <div className="counter">$130 trillion</div>
                      <p>commited to net-zero portfolios by 2050 (Glasgow Financial Alliance for Net Zero)</p>
                    </div>
                </Col>
              </Row>
        </div>
      </div>
    </div>
  );
};

export default WhyGreen;